import { createSlice } from '@reduxjs/toolkit';
import { enumWorkflowState } from '../../../dataObjects/enums';

const initialState: enumWorkflowState | null = null;

// whether to display console logs (displayConsoleLogs && console.log statements)
const displayConsoleLogs: boolean = false;

export const userRegistrationStatusSlice = createSlice({
  name: 'userRegistrationStatus',
  initialState,
  reducers: {
    // action has a payload with the new enumWorkflowState value or null
    userRegistrationStatusChange(state, action) {
      displayConsoleLogs && console.log(`userRegistrationStatusSlice. Processing userRegistrationStatusChange.`);
      // change status of registration process
      return action.payload;
    },

  },
})

// Action creators are generated for each function in reducer)
export const { userRegistrationStatusChange } = userRegistrationStatusSlice.actions;

// export the core reducer for the slice
export const userRegistrationStatusReducer = userRegistrationStatusSlice.reducer;

export default userRegistrationStatusSlice.reducer;